import { useLoginRequest, useOtpRequest, useRegisterRequest } from "@/app/api"
import { changeRetryInSeconds } from "@/app/appSlice"
import { RootState } from "@/app/store"
import OtpInput from "react-otp-input"

export default function Otp() {
  const [otp, setOtp] = useState("")
  const [errMsg, setErrMsg] = useState("")
  const t = useTranslate()
  const dispatch = useAppDispatch()
  const otpRequest = useOtpRequest()
  const login = useLoginRequest()
  const register = useRegisterRequest()

  const phone = useAppSelector((state: RootState) => state.app.phone)
  const countryCode = useAppSelector(
    (state: RootState) => state.app.countryCode,
  )
  const email = useAppSelector((state: RootState) => state.app.email)
  const code = useAppSelector((state: RootState) => state.app.code)
  const _retryTime = useAppSelector(
    (state: RootState) => state.app.retryInSeconds,
  )
  const mode = useAppSelector((state: RootState) => state.app.mode)
  const [retryTime, setRetryTime] = useState(_retryTime)
  const [retry, setRetry] = useState(false)

  const otpTarget = useAppSelector((state: RootState) => state.app.otpTarget)

  const submit = async (otp: string) => {
    const response = await otpRequest(otp)
    if (!response.success) {
      setErrMsg(response.error)
    }
    // response.success
  }

  const onOtpChange = (otp: string) => {
    setOtp(otp)
  }

  useEffect(() => {
    const interval = setTimeout(() => {
      if (retryTime > 0) {
        setRetryTime(retryTime - 1)
      } else {
        clearTimeout(interval)
      }
    }, 1000)
    return () => clearTimeout(interval)
  }, [retryTime])

  const resend = async () => {
    let res = { success: false, error: "", retryInSeconds: 0 }
    if (mode === "sign_in") {
      res = await login(countryCode + phone, email, code)
    } else if (mode === "register") {
      res = await register(countryCode + phone, email, code)
    }

    if (!res.success) {
      setErrMsg(res.error)
      return
    }
    setTimeout(() => {
      setRetry(false)
    }, 5000)
    setRetry(true)
    dispatch(changeRetryInSeconds(res.retryInSeconds))
    setRetryTime(res.retryInSeconds)
  }

  return (
    <div>
      <div className="text-2xl font-bold mt-5">{t(mode)}</div>
      <div className="text-2xl font-bold mt-3 mb-5">{t("otp_header")}</div>
      <div className="mt-2 mb-10">{t("otp_header_sub", { otpTarget })}</div>
      <OtpInput
        value={otp}
        onChange={onOtpChange}
        numInputs={6}
        renderInput={(props) => <input {...props} />}
        containerStyle="grid grid-cols-6 gap-2"
        // className=""
        inputStyle={clsx([
          { "border-red-500 border-1": !!errMsg, "border-0": !!!errMsg },
          "otp bg-neutral-100 rounded-lg text-2xl grow py-5",
        ])}
      />
      {errMsg && (
        <div className="text-red-500 mt-1 text-left text-xs">{t(errMsg)}</div>
      )}

      <div className="mt-4 mb-6 text-left text-neutral-400 text-sm">
        <span className="mr-2">
          {!retry && t("otp_resend")}
          {retry && t("otp_resent")}
        </span>
        {retryTime > 0 && (
          <span>{t("otp_resend_time", { time: retryTime })}</span>
        )}
        {retryTime <= 0 && (
          <button
            className={`m-0 p-0 border-0 bg-transparent font-bold`}
            onClick={() => resend()}
          >
            {t("otp_resend_button")}
          </button>
        )}
      </div>
      {/* <div > */}
      <button
        className={`w-full m-0`}
        onClick={() => submit(otp)}
        disabled={otp.length !== 6}
      >
        {t("confirm")}
      </button>
      {/* </div> */}
    </div>
  )
}
